jQuery(document).ready(function ($) {

  // ==========================================================================
  // 1. Disable Right-Click on Images
  // ==========================================================================
  $(document).on('contextmenu', 'img, .gslide-media img, .gslide-image img', function () {
    return false;
  });

  // ==========================================================================
  // 2. Header Show/Hide on Scroll
  // ==========================================================================
  const $header = $('.page-header');
  let lastScrollY = $(window).scrollTop();
  let hideTimeout;

  function handleScroll() {
    const currentY = Math.round($(window).scrollTop());

    if (currentY <= 0) {
      $header.removeClass('header--hidden');
      clearTimeout(hideTimeout);
    } else if (currentY > lastScrollY) {
      $header.addClass('header--hidden');
      clearTimeout(hideTimeout);
    } else {
      $header.removeClass('header--hidden');
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        $header.addClass('header--hidden');
      }, 1500);
    }

    lastScrollY = currentY;
  }

  $(window).on('scroll', handleScroll);
  $header.on('mouseenter', () => clearTimeout(hideTimeout));

  // ==========================================================================
  // 3. Submenu Arrows (Desktop & Mobile)
  // ==========================================================================
document.querySelectorAll('.primary-navigation .menu-item-has-children, #primary-menu-mobile .menu-item-has-children')
  .forEach(item => {
    const link = item.querySelector('a');
    const href = link?.getAttribute('href');
    const isInactiveLink = !href || href === '#' || href.trim() === '';

    // Submenu Toggle Button (z. B. im Mobile-Menü)
    if (!item.querySelector('.submenu-toggle')) {
      const button = document.createElement('button');
      button.className = 'submenu-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Untermenü öffnen');
      button.innerHTML = `
        <svg class="icon icon-arrow" viewBox="0 0 24 24" aria-hidden="true">
          <polyline points="6 9 12 15 18 9" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
      item.appendChild(button);

      button.addEventListener('click', e => {
        e.preventDefault();
        toggleSubmenu(item, button);
      });
    }

    // Click auf Link ohne echte URL (z. B. individuelle Links ohne href)
    if (isInactiveLink) {
      link?.addEventListener('click', e => {
        e.preventDefault();
        const button = item.querySelector('.submenu-toggle');
        toggleSubmenu(item, button);
      });
    }
  });

function toggleSubmenu(parent, button) {
  const submenu = parent.querySelector('.sub-menu');

  document.querySelectorAll('.menu-item-has-children').forEach(i => {
    if (i !== parent) {
      i.classList.remove('is-open');
      i.querySelector('.submenu-toggle')?.setAttribute('aria-expanded', 'false');
      i.querySelector('.sub-menu')?.classList.remove('sub-menu-open');
    }
  });

  const isOpen = parent.classList.toggle('is-open');
  button?.setAttribute('aria-expanded', isOpen);
  if (submenu) submenu.classList.toggle('sub-menu-open', isOpen);
}


  // ==========================================================================
  // 4. Mobile Menu Toggle & Body Scroll Lock
  // ==========================================================================
  const $root = $('html, body');
  const $nav = $('.page-header__mobile');

  $(document).on('click', '.hamburger-container', function (e) {
    e.preventDefault();
    $root.toggleClass('no-scroll');
    $nav.toggleClass('active');
  });

  $nav.on('click', 'a', function (e) {
    const href = $(this).attr('href');
    if (!href || href === '#' || href.trim() === '') {
      e.preventDefault(); 
      return;
    }
    $root.removeClass('no-scroll');
    $nav.removeClass('active');
  });

  // ==========================================================================
  // 5. FAQ Accordion
  // ==========================================================================
  $('.faq-toggle').on('click', function () {
    const $btn = $(this);
    const idx = $btn.attr('id')?.replace('faq-toggle-', '');
    if (!idx) return;

    const $content = $(`#faq-list__item--content-${idx}`);
    const isOpen = $btn.attr('aria-expanded') === 'true';

    $btn
      .attr('aria-expanded', !isOpen)
      .toggleClass('is-open', !isOpen);

    $content
      .slideToggle(300)
      .attr('hidden', isOpen);
  });

  // ==========================================================================
  // 6. Content-Menu Toggle
  // ==========================================================================
  $('.content__menu').on('click', function () {
    $(this).toggleClass('menu-open');
  });

  // ==========================================================================
  // 7. Dynamische CSS-Variable: --vh (Viewport Height minus Header)
  // ==========================================================================
  function updateVh() {
    const headerH = $header.outerHeight() || 0;
    const vh = (window.innerHeight - headerH) * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  updateVh();
  $(window).on('resize orientationchange', () => {
    setTimeout(updateVh, 100);
  });

  // ==========================================================================
  // 8. Visited-State im Header
  // ==========================================================================
  const currentUrl = window.location.href.split(/[?#]/)[0];
  $('.page-header a').each(function () {
    if ($(this).prop('href') === currentUrl) {
      $(this).addClass('is-visited')
        .closest('.menu-item-has-children')
        .children('a')
        .addClass('is-visited');
    }
  });

}); // End of document.ready

// ==========================================================================
// 9. Scroll-Down Arrow Logic (nach vollständigem Seitenaufbau)
// ==========================================================================
jQuery(window).on('load', function () {
  const $ = jQuery;
  const $arrow = $('.scroll-down-arrow');
  const $hero = $('.block-site-hero, .block-slider-hero');
  let $target = $('#scroll-target');

  // Dynamisch ID setzen
  if (!$target.length && $hero.length) {
    const $nextSection = $hero.nextAll('section').first();
    if ($nextSection.length) {
      $nextSection.attr('id', 'scroll-target');
      $target = $nextSection;
    }
  }

  if (!$target.length) {
    console.warn('Kein #scroll-target gefunden.');
    return;
  }

  // Pfeil immer einblenden
  $arrow.show();
});


// Scroll mit -32px Offset beim Klick auf Pfeil
jQuery(document).on('click', '.scroll-down-arrow', function (e) {
  e.preventDefault();
  const $target = jQuery('#scroll-target');

  if ($target.length) {
    const offsetTop = $target.offset().top - 32;
    jQuery('html, body').animate({ scrollTop: offsetTop }, 400);
  }
});

// ==========================================================================
// 10. Add Controls to Video on Hover
// ==========================================================================

jQuery(document).ready(function($) {
    $('.block-video__wrapper').each(function () {
        const $wrapper = $(this);
        const videoEl = $wrapper.find('video').get(0);
        const $playBtn = $wrapper.find('.block-video__play-button');

        // Versuche Autoplay
        const playPromise = videoEl.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                $playBtn.css('display', 'none');
            }).catch(() => {
                $playBtn.css('display', 'block');
            });
        }

        // Manuell starten
        $playBtn.on('click', function(e) {
            e.stopPropagation();
            videoEl.play();
            $playBtn.css('display', 'none');
        });
    });
});







